import { Injectable, inject } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { AuthService } from './auth.service';

/**
 * @deprecated Contrato del extinto `POST ${apiUrl}/auth/refresh`; se conserva solo por
 * compatibilidad de tipos hasta eliminar el servicio.
 */
export interface TokenRefreshResponse {
  access_token: string;
  refresh_token?: string; // Hacer opcional por si el backend no siempre lo envía
  expires_in: number;
}

/**
 * @deprecated Apuntaba a `POST ${apiUrl}/auth/refresh`, endpoint que no existe en el
 * backend FastAPI (causa del cierre de sesión del Mantis #15). El refresh de sesión se
 * consolidó en `AuthService.refreshToken()` contra el OAuth2 de Simappe, con recuperación
 * de 401 en `errorInterceptor`. Este servicio queda como fachada que delega en ese flujo
 * para no romper a sus consumidores actuales. No agregar nuevos consumidores; pendiente
 * de eliminación.
 *
 * El single-flight vive en `AuthService.refreshToken()`; no duplicar candados aquí.
 */
@Injectable({ providedIn: 'root' })
export class VaultTokenRefreshService {
  private readonly authService = inject(AuthService);

  refreshToken(): Observable<string> {
    return this.authService.refreshToken().pipe(
      map((content) => content.accessToken),
      tap(() => {
        if (typeof window !== 'undefined') {
          sessionStorage.setItem('token_timestamp', Date.now().toString());
          window.dispatchEvent(new CustomEvent('vault-session-updated'));
        }
      }),
    );
  }
}
